import {
    /* Autocomplete, */
    Box,
    Button,
    Checkbox,
    Grid,
    Icon,
    IconButton,
    Modal,
    /* TextField, */
    Typography,
} from '@mui/material';
import { DataGrid, GridToolbar, esES } from '@mui/x-data-grid';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import {
    ArrowDropDown,
    Edit,
    Event,
    Feedback,
    Shortcut,
} from '@mui/icons-material';
import { sendRequest } from '../../../../services/request';
import DetalleCliente from './detalle';
import Historial from './historial';
import NuevoCliente from './nuevo_cliente';
import Preventa from './preventa';
import ListHeader from './listHeader';
import { useSelector } from 'react-redux';
import useTabActive from '../../../../hooks/useTabActive';
import { DataGridStyle } from '../../../../styles/DataGridSytle';
import ModalEvento from '../agenda/modalEvento';
import ActionConfirmation from '../../../../components/utils-components/ActionConfirmation/ActionConfirmation';
import { ContactabilidadEditCell } from '../../../../components/utils-components/DataGrid/ContactabilidadEditCell/ContactabilidadEditCell';
import { useSingleClickEdit } from '../../../../hooks/useSingleClickEdit';
import RechazoModal from '../../inventario/enviosClientesFinales/modalRechazo';
import FileUploadCell from '../../../../components/utils-components/DataGrid/FileUpload/FileUploadCell';

const MiBD = ({ pais }) => {
    const [rows, setRows] = useState();
    const [limit, setLimit] = useState(50);
    const [page, setPage] = useState(0);
    const [rowCount, setRowCount] = useState(null);
    const [clientRow, setClientRow] = useState(null);
    const [open, setOpen] = useState(false);

    const [departamento, setDepartamento] = useState(null);

    //Condicionales
    const [isEditing, setIsEditing] = useState(false);
    const [verHistorial, setVerHistorial] = useState(false);
    const [loading, setLoading] = useState(true);

    // Listas
    const [tipoDocumentos, setTipoDocumentos] = useState([]);
    const [generos, setGeneros] = useState([]);
    const [estadosCiviles, setEstadosCiviles] = useState([]);
    const [edadesHijos, setEdadesHijos] = useState([]);
    const [nivelDeEstudios, setNivelDeEstudios] = useState([]);
    const [departamentos, setDepartamentos] = useState([]);
    const [ciudades /* setCiudades */] = useState([]);
    const [contactabilidades, setContactabilidades] = useState([]);
    const [mediosPago, setMediosPago] = useState([]);

    // Filtros
    const [filtros, setFiltros] = useState({
        searchNombres: '',
        searchApellidos: '',
        searchCelular: '',
        contactabilidad: 'contactabilidad',
    });

    // Modales
    const [openModal, setOpenModal] = useState({
        observacion: false,
    });

    const URL = `${process.env.REACT_APP_API_URL}`;
    const location = useLocation();
    const isTabActive = useTabActive();

    // Datos en el locations desde Campana
    const campana = location.state?.campana;

    //Modal
    const [openDetalle, setOpenDetalle] = useState(false);
    const [openCreate, setOpenCreate] = useState(false);
    const [openPreventa, setOpenPreventa] = useState(false);
    const [openEvento, setOpenEvento] = useState(false);

    //Re-render
    const [guardado, setGuardado] = useState(false);

    //ActionConfirmation
    const [actionConfirmation, setActionConfirmation] = useState({
        openModal: false,
        type: null,
        title: '',
        message: '',
        okButton: '',
        data: null,
    });

    // SingleClickEditing
    const { cellModesModel, handleCellClick, handleCellModesModelChange } =
        useSingleClickEdit();

    const usuario = useSelector((state) => state.auth.usuario);

    useEffect(() => {
        setLoading(true);
        sendRequest(
            'get',
            `${URL}/${pais}/clientes-asignados/campana/${
                campana?.id
            }/promotor/${
                usuario?.id
            }?page=${page}&limit=${limit}&searchNombres=${
                filtros.searchNombres
            }&searchApellidos=${filtros.searchApellidos}&searchCelular=${
                filtros.searchCelular
            }&contactabilidad=${
                filtros.contactabilidad !== 'contactabilidad'
                    ? filtros.contactabilidad
                    : ''
            }`,
        )
            .then((res) => {
                setLoading(false);
                setRows(res.data.items);
                setRowCount(res.data.meta.totalItems);
            })
            .catch((err) => {
                console.log(err);
                setLoading(false);
            });
    }, [
        URL,
        pais,
        campana?.id,
        limit,
        page,
        guardado,
        filtros.searchNombres,
        filtros.searchApellidos,
        filtros.searchCelular,
        filtros.contactabilidad,
        usuario?.id,
        isTabActive,
    ]);

    useEffect(() => {
        sendRequest('get', `${URL}/${pais}/contactabilidad`).then((res) =>
            setContactabilidades(res.data),
        );
        sendRequest('get', `${URL}/${pais}/tipo-documentos`).then((res) => {
            setTipoDocumentos(res.data);
        });

        sendRequest('get', `${URL}/${pais}/genero`).then((res) =>
            setGeneros(res.data),
        );

        sendRequest('get', `${URL}/${pais}/estado-civil`).then((res) =>
            setEstadosCiviles(res.data),
        );

        sendRequest('get', `${URL}/${pais}/estado-civil`).then((res) =>
            setEdadesHijos(res.data),
        );

        sendRequest('get', `${URL}/${pais}/edades-hijos`).then((res) =>
            setEdadesHijos(res.data),
        );

        sendRequest('get', `${URL}/${pais}/estudios`).then((res) =>
            setNivelDeEstudios(res.data),
        );

        sendRequest('get', `${URL}/${pais}/departamentos`).then((res) =>
            setDepartamentos(res.data),
        );
        sendRequest('get', `${URL}/${pais}/medio-pago`).then((res) =>
            setMediosPago(res.data),
        );
    }, [URL, pais]);

    const columns = [
        {
            field: 'nombres',
            headerName: 'Nombres',
            flex: 1,
            headerClassName: 'header',
            headerAlign: 'center',
            sortable: false,
            renderCell: ({ row }) => row.cliente?.nombres,
        },
        {
            field: 'apellidos',
            headerName: 'Apellidos',
            headerClassName: 'header',
            headerAlign: 'center',
            sortable: false,
            flex: 1,
            renderCell: ({ row }) => row.cliente?.apellidos,
        },
        {
            field: 'celular',
            headerName: 'Celular',
            headerClassName: 'header',
            headerAlign: 'center',
            sortable: false,
            renderCell: ({ row }) => row.cliente?.celular,
        },
        {
            field: 'whatsapp',
            headerName: 'WhatsApp',
            headerClassName: 'header',
            headerAlign: 'center',
            align: 'center',
            sortable: false,
            renderCell: ({ row }) => {
                /* if (row.cliente?.celular) {
                    return <Check></Check>;
                } else {
                    return <Clear></Clear>;
                } */
                return (
                    <Checkbox
                        checked={row.cliente?.tiene_whatsapp}
                        onChange={async (event) => {
                            await sendRequest(
                                'put',
                                `${URL}/${pais}/cliente/${row.cliente?.id}`,
                                {
                                    tiene_whatsapp: event.target.checked,
                                },
                            );
                            setGuardado(!guardado);
                        }}
                    ></Checkbox>
                );
            },
        },
        {
            field: 'contactabilidad',
            headerName: 'Contactabilidad',
            headerClassName: 'header',
            headerAlign: 'center',
            align: 'center',
            sortable: false,
            flex: 1,
            type: 'singleSelect',
            valueOptions: contactabilidades,
            getOptionValue: (contactabilidad) => contactabilidad?.id,
            getOptionLabel: (contactabilidad) =>
                contactabilidad.nombre === 'Preventa' &&
                campana.division?.id === 2
                    ? 'Donación Efectiva'
                    : contactabilidad.nombre,
            editable: true,
            renderEditCell: (params) => (
                <ContactabilidadEditCell
                    params={params}
                    contactabilidades={contactabilidades}
                    campana={campana}
                />
            ),
            renderCell: ({ row }) => {
                return (
                    <Grid
                        container
                        display={'flex'}
                        justifyContent={'center'}
                        alignItems={'center'}
                    >
                        <Grid item xs={11}>
                            <Typography>
                                {row.contactabilidad.nombre === 'Preventa' &&
                                campana.division?.id === 2
                                    ? 'Donación Efectiva'
                                    : row.contactabilidad.nombre}
                            </Typography>
                        </Grid>
                        <Grid item xs={1} pt={0.5}>
                            <Icon>
                                <ArrowDropDown />
                            </Icon>
                        </Grid>
                    </Grid>
                );
            },
            /* renderCell: ({ row }) => {
                return (
                    <Autocomplete
                        disablePortal
                        fullWidth
                        value={row.contactabilidad}
                        options={contactabilidades}
                        getOptionLabel={(option) => option.nombre}
                        size="small"
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                placeholder=""
                                variant="standard"
                            />
                        )}
                        readOnly={row.contactabilidad.id === 4}
                        onChange={(element, value) => {
                            if (value.id === 4) {
                                window.open(
                                    `https://form.jotform.com/${
                                        row.campana.jotform_id
                                    }?ciudad=${
                                        row.campana.ciudad.nombre
                                    }&nombre=${row.cliente.nombres}&apellidos=${
                                        row.cliente.apellidos
                                    }&numero_documento=${
                                        row.cliente.numero_documento
                                    }&celular=${row.cliente.celular}&correo=${
                                        row.cliente.correo
                                    }&empresa=${row.cliente.empresa}&promotor=${
                                        usuario.nombres +
                                        ' ' +
                                        usuario.apellidos
                                    }`,
                                    '_blank',
                                );
                            } else {
                                handleContactabilidadSelect(row.id, value.id);
                            }
                        }}
                    ></Autocomplete>
                );
            }, */
        },
        {
            field: 'acciones',
            type: 'actions',
            cellClassName: 'actions',
            headerName: 'Acciones',
            headerClassName: 'header',
            flex: 1.5,
            renderCell: ({ row }) => {
                return (
                    <>
                        <IconButton
                            color="primary"
                            size="small"
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                borderRadius: 0,
                            }}
                            onClick={() => handleEditClick(row.cliente)}
                        >
                            <Edit />
                            <Typography
                                sx={{
                                    textAlign: 'center',
                                    whiteSpace: 'normal',
                                    wordBreak: 'break-word',
                                    maxWidth: 60,
                                    lineHeight: 1.1,
                                }}
                            >
                                Editar
                            </Typography>
                        </IconButton>
                        <IconButton
                            color="text"
                            size="small"
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                borderRadius: 0,
                            }}
                            onClick={() => handleDetailsClick(row.cliente)}
                        >
                            <Shortcut />
                            <Typography
                                sx={{
                                    textAlign: 'center',
                                    whiteSpace: 'normal',
                                    wordBreak: 'break-word',
                                    maxWidth: 60,
                                    lineHeight: 1.1,
                                }}
                            >
                                Ver Detalle
                            </Typography>
                        </IconButton>
                        <IconButton
                            color="text"
                            size="small"
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                borderRadius: 0,
                            }}
                            onClick={() => handleCrearEvento(row.cliente)}
                        >
                            <Event />
                            <Typography
                                sx={{
                                    textAlign: 'center',
                                    whiteSpace: 'normal',
                                    wordBreak: 'break-word',
                                    maxWidth: 60,
                                    lineHeight: 1.1,
                                }}
                            >
                                Crear Evento
                            </Typography>
                        </IconButton>
                        {row?.cliente?.envio?.confirmado === false && (
                            <>
                                <FileUploadCell
                                    handleFileChange={(e) =>
                                        handleFileChange(e, row?.cliente?.envio)
                                    }
                                />
                                {/* <IconButton
                                    color="text"
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        borderRadius: 0,
                                    }}
                                    onClick={() =>
                                        handleSubirArchivo(row.cliente)
                                    }
                                >
                                    <DocumentScanner />
                                    <Typography>Editar Stub</Typography>
                                </IconButton> */}
                                <IconButton
                                    disabled={row.estado?.id === 9}
                                    color="primary"
                                    size="small"
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        borderRadius: 0,
                                        alignItems: 'center',
                                        maxWidth: 80,
                                    }}
                                    onClick={() => handleOpenObservacion(row)}
                                >
                                    <Feedback />
                                    <Typography
                                        variant="caption"
                                        color="primary"
                                        sx={{
                                            textAlign: 'center',
                                            whiteSpace: 'normal',
                                            wordBreak: 'break-word',
                                            maxWidth: 60,
                                            lineHeight: 1.1,
                                        }}
                                    >
                                        Ver obs.
                                    </Typography>
                                </IconButton>
                            </>
                        )}
                    </>
                );
            },
        },
    ];

    const handleFileChange = async (e, row) => {
        const file = e.target.files[0];
        if (!file) return;

        const formData = new FormData();
        formData.append('file', file);

        try {
            await sendRequest(
                'patch',
                `${URL}/${pais}/envio/${row.id}/image`,
                formData,
                {
                    headers: { 'Content-Type': 'multipart/form-data' },
                },
            );
            setGuardado(!guardado);
        } catch (error) {
            console.error('Error al subir imagen', error);
            alert('Error al subir la imagen');
        }
    };

    // const handleSubirArchivo = async (row) => {
    //     const formData = new FormData();
    //     formData.append('file', file);
    //     // window.open(
    //     //     `https://www.jotform.com/edit/${row.envio.jotform_submission_id}`,
    //     //     '_blank',
    //     // );
    // };

    const handleContactabilidadSelect = async (id, contactabilidad) => {
        try {
            await sendRequest(
                'patch',
                `${URL}/${pais}/clientes-asignados/contactabilidad`,
                {
                    id,
                    contactabilidad,
                },
            );
            setGuardado(!guardado);
        } catch (error) {
            console.log(error);
        }
    };

    const handleEditClick = (row) => {
        setClientRow(row);
        setOpen(true);
        setOpenDetalle(true);
        setIsEditing(true);
    };

    const handleDetailsClick = (row) => {
        setClientRow(row);
        setOpen(true);
        setOpenDetalle(true);
    };

    const handleCrearEvento = (row) => {
        setClientRow(row);
        setOpen(true);
        setOpenEvento(true);
    };

    const handleCreateClick = () => {
        setOpen(true);
        setOpenCreate(true);
    };

    const handleOpenObservacion = (row) => {
        setOpenModal({ ...openModal, observacion: true });
        setClientRow(row);
    };

    const handleClose = () => {
        setOpen(false);
        setOpenDetalle(false);
        setIsEditing(false);
        setVerHistorial(false);
        setOpenCreate(false);
        setOpenPreventa(false);
        setOpenEvento(false);
        setDepartamento(null);
        setActionConfirmation({ ...actionConfirmation, openModal: false });
        setOpenModal({ ...openModal, observacion: false });
    };

    const handlePaginationChange = (event) => {
        setPage(event.page);
        setLimit(event.pageSize);
    };

    const handleVerHistorial = () => {
        setVerHistorial(true);
    };

    const handleAtras = () => {
        setVerHistorial(false);
    };

    const handleCrear = async (newData) => {
        try {
            await sendRequest('post', `${URL}/${pais}/cliente`, newData);
            handleClose();
            setGuardado(!guardado);
        } catch (error) {}
    };

    const handleGuardar = async (updatedData) => {
        try {
            await sendRequest(
                'put',
                `${URL}/${pais}/cliente/${updatedData?.id}`,
                updatedData,
            );
            setOpen(false);
            setGuardado(!guardado);
        } catch (error) {
            console.log(error);
        }
    };

    const handleAgendar = async (dataAgendar) => {
        try {
            await sendRequest('post', `${URL}/${pais}/envio`, dataAgendar);
            setOpen(false);
            setGuardado(!guardado);
        } catch (error) {
            console.log(error);
        }
    };

    const handleGuardarEvento = async (dataEvento) => {
        try {
            await sendRequest('post', `${URL}/eventos`, {
                ...dataEvento,
                usuario,
            });
            handleClose();
        } catch (error) {
            console.log(error);
        }
    };

    const handleRowUpdate = (updatedRow, originalRow) => {
        if (updatedRow.contactabilidad.id === 3) {
            window.open(
                `https://wa.me/${pais === 'colombia' ? '+57' : '+507'}${
                    originalRow.cliente.celular
                }`,
            );
            handleContactabilidadSelect(
                updatedRow.id,
                updatedRow.contactabilidad,
            );
        } else if (updatedRow.contactabilidad.id === 4) {
            window.open(
                `https://form.jotform.com/${
                    originalRow?.campana?.jotform_id
                }?ciudad=${originalRow?.campana?.ciudad?.nombre}&nombres=${
                    originalRow?.cliente?.nombres
                }&apellidos=${
                    originalRow?.cliente?.apellidos
                }&numero_documento=${
                    originalRow?.cliente?.numero_documento
                }&celular=${originalRow?.cliente?.celular}&correo=${
                    originalRow?.cliente?.correo
                }&empresa=${originalRow?.cliente?.empresa}&promotor=${
                    usuario?.nombres + ' ' + usuario?.apellidos
                }&idPromotor=${usuario?.id}&codigoPromotor=${usuario?.codigo}`,
                '_blank',
            );
        } else if (updatedRow.contactabilidad.id === 5) {
            const nombreCliente = `${updatedRow.cliente.nombres} ${updatedRow.cliente.apellidos}`;
            setOpen(true);
            setActionConfirmation({
                ...actionConfirmation,
                title: `¿Está seguro de no contactar más a ${nombreCliente}?`,
                message: `Esto eliminará el cliente de la base de datos.`,
                openModal: true,
                data: updatedRow,
                okButton: 'Eliminar',
            });
        } else {
            handleContactabilidadSelect(
                updatedRow.id,
                updatedRow.contactabilidad,
            );
        }
        return updatedRow;
    };

    const handleProcessRowUpdateError = (error) => {
        console.log(error);
    };

    const handleNoContactar = async (data) => {
        const { id, contactabilidad, cliente } = data;
        try {
            await sendRequest('delete', `${URL}/${pais}/cliente/${cliente.id}`);
            handleContactabilidadSelect(id, contactabilidad);
            handleClose();
        } catch (error) {
            console.log(error);
        }
    };

    const handleIsCellEditable = (params) => {
        return params.row.contactabilidad.nombre !== 'Preventa';
    };

    const handleRowClassName = ({ field, row }) => {
        if (row.contactabilidad.id === 4) {
            if (row?.cliente?.envio?.confirmado === null)
                return 'row-pendiente';
            if (row?.cliente?.envio?.confirmado) return 'row-confirmado';
            return 'row-no-confirmado';
        }
    };

    return (
        <>
            <Box sx={{ height: '100%', width: '100%' }}>
                <Grid container spacing={5} py={3} pr={3}>
                    <Grid item xs={12} md={8}>
                        <Typography
                            variant="h4"
                            color="primary"
                            sx={{
                                textAlign: 'start',
                                marginLeft: '10px',
                            }}
                        >
                            Clientes por Contactar / {campana.nombre}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Button
                            fullWidth
                            variant="contained"
                            onClick={handleCreateClick}
                        >
                            Cliente Nuevo
                        </Button>
                    </Grid>
                </Grid>
                <ListHeader
                    filtros={filtros}
                    setFiltros={setFiltros}
                    contactabilidades={contactabilidades}
                    campana={campana}
                ></ListHeader>
                <DataGrid
                    getRowId={(row) => row.cliente.id}
                    localeText={
                        esES.components.MuiDataGrid.defaultProps.localeText
                    }
                    disableColumnSelector
                    disableDensitySelector
                    disableColumnFilter
                    disableColumnMenu
                    disableRowSelectionOnClick
                    loading={loading}
                    initialState={{
                        pagination: {
                            paginationModel: { pageSize: limit },
                        },
                    }}
                    rows={rows ? rows : []}
                    columns={columns}
                    slots={{
                        toolbar: GridToolbar,
                    }}
                    slotProps={{
                        toolbar: {
                            showQuickFilter: false,
                            // Estos dos quitan el export
                            printOptions: { disableToolbarButton: true },
                            csvOptions: { disableToolbarButton: true },
                        },
                    }}
                    paginationMode="server"
                    rowCount={rowCount ? rowCount : 0}
                    onPaginationModelChange={handlePaginationChange}
                    processRowUpdate={handleRowUpdate}
                    onProcessRowUpdateError={handleProcessRowUpdateError}
                    isCellEditable={handleIsCellEditable}
                    getRowClassName={handleRowClassName}
                    getRowHeight={() => 'auto'}
                    editMode="cell" // Todo estos 4 parametros y el hook son usados para el manejo de el edit con solo un click
                    cellModesModel={cellModesModel}
                    onCellClick={handleCellClick}
                    onCellModesModelChange={handleCellModesModelChange}
                    sx={[
                        DataGridStyle,
                        {
                            '& .MuiDataGrid-virtualScroller': {
                                minHeight: '30vh',
                            },
                            '& .row-pendiente': {
                                backgroundColor: 'envio_pendiente.main',
                            },
                            '& .row-confirmado': {
                                backgroundColor: 'envio_confirmado.main',
                            },
                            '& .row-no-confirmado': {
                                backgroundColor: 'envio_no_confirmado.main',
                            },
                        },
                    ]}
                />
            </Box>
            <RechazoModal
                open={openModal.observacion}
                isEditing={false}
                onClose={handleClose}
                row={clientRow?.cliente?.envio}
            />
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <div>
                    {openDetalle && (
                        <DetalleCliente
                            handleVerHistorial={handleVerHistorial}
                            handleClose={handleClose}
                            clientRow={clientRow}
                            setClientRow={setClientRow}
                            isEditing={isEditing}
                            setIsEditing={setIsEditing}
                            handleGuardar={handleGuardar}
                            tipoDocumentos={tipoDocumentos}
                            generos={generos}
                            estadosCiviles={estadosCiviles}
                            edadesHijosList={edadesHijos}
                            nivelDeEstudiosList={nivelDeEstudios}
                            departamentosList={departamentos}
                            departamento={departamento}
                            setDepartamento={setDepartamento}
                            ciudadesList={ciudades}
                        ></DetalleCliente>
                    )}
                    {openCreate && (
                        <NuevoCliente
                            pais={pais}
                            handleCrear={handleCrear}
                            handleClose={handleClose}
                            tipoDocumentos={tipoDocumentos}
                            generos={generos}
                            estadosCiviles={estadosCiviles}
                            edadesHijosList={edadesHijos}
                            nivelDeEstudiosList={nivelDeEstudios}
                            departamentosList={departamentos}
                            departamento={departamento}
                            setDepartamento={setDepartamento}
                            ciudadesList={ciudades}
                        ></NuevoCliente>
                    )}
                    {openEvento && (
                        <ModalEvento
                            title={`Llamar a ${clientRow?.nombres || ''} ${
                                clientRow?.apellidos || ''
                            }`}
                            handleClose={handleClose}
                            handleGuardar={handleGuardarEvento}
                        ></ModalEvento>
                    )}
                    {verHistorial && (
                        <Historial
                            handleClose={handleClose}
                            clientRow={clientRow}
                            handleAtras={handleAtras}
                            pais={pais}
                        ></Historial>
                    )}
                    {openPreventa && (
                        <Preventa
                            cliente={clientRow}
                            mediosPago={mediosPago}
                            handleClose={handleClose}
                            handleAgendar={handleAgendar}
                        ></Preventa>
                    )}
                    {actionConfirmation.openModal && (
                        <ActionConfirmation
                            type={actionConfirmation.type}
                            title={actionConfirmation.title}
                            message={actionConfirmation.message}
                            handleClose={handleClose}
                            handleConfirm={handleNoContactar}
                            data={actionConfirmation.data}
                            okButton={actionConfirmation.okButton}
                        />
                    )}
                </div>
            </Modal>
        </>
    );
};

export default MiBD;
